var CategoryPicker = require("components/cloze/CategoryPicker.js")
var Passage = require("components/cloze/Passage.js")
var ClozeIcons = require("components/cloze/ClozeIcons.js");

var Spinner = require("components/utility/Spinner");
var StudentClozeStatus = require('components/users/students/StudentClozeStatus');

var CurrentUser = require("lib/account/CurrentUser");
var WhooosReadingClozeApi = require("wr_apis/apis/cloze_api/node_package/src/index.js")

require("cloze/cloze_page.scss");

class ClozePage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = this.getInitialState();
	}

	reset() {
		this.setState(this.getInitialState(), this.fetchCategories);
	}

	getInitialState() {
		return {			
			// State used for CategoryPicker
			categories: null, passages: {}, selectedCategory: null,

			// State used to display passages
			selectedPassage: null, selectedPassageDetails: null,

			// State used in the completion state
			finalLoading: false, postClozeStatus: null
		}
	}

	showError() {
		if (this.state.postClozeStatus && this.state.postClozeStatus.current > 40) {
			$wr.redirect("/");
		} else {
			window.wrNotifications.triggerDropDownNotification({
				title: "We're having trouble loading this page",
				text: "Please try refreshing the page or coming back later.",
				icon: "exclamation-sign", type: "error"
			}, 6000);
		}
	}

	selectCategory(category) {
		this.setState({ selectedCategory: category }, this.fetchPassages);
	}

	fetchPassages() {
		var category = this.state.selectedCategory;
		if (category && !(category.categoryName in this.state.passages)) {
			var params = { categories: category.categoryName, passage_type: category.passageType };

			this.clozeClient.getPassages(params).then((response) => {
				var newPassages = _.clone(this.state.passages);
				var passageKey = category.categoryName + "-" + category.passageType;
				newPassages[passageKey] = response.passages;
				this.setState({ passages: newPassages }, () => {
					$wr.scrollToElement($(this.refs.wrap).find(".passageOptions"), 100)
				});
			}).catch((error) => {
				this.showError()
			});
		}
	}

	selectPassage(passage) {
		// Pick a sample passage at random
		this.setState({ selectedPassage: passage }, () => {
			this.clozeClient.getPassage(passage.passageId).then((response) => {
				if (response.passage) {
					this.setState({ selectedPassageDetails: response.passage });					
				} else {
					console.error(response);
				}
			}).catch((error) => {
				this.showError()
			});
		});
	}

	onPassageComplete(completionData) {
		var assessment = {
			passage_id: this.state.selectedPassage.passageId,
			completions: completionData
		}
		this.setState({ finalLoading: true });

		this.clozeClient.postAssessments({ assessment: assessment }).then((response) => {
			CurrentUser.fetchCurrentUserCoinData();
			this.setState({ finalLoading: false, postClozeStatus: response.status });
		}).catch((error) => {
			this.showError()
		});
	}

	getCategoryPassages() {
		if (!this.state.selectedCategory) { return; }
		var passageKey = this.state.selectedCategory.categoryName + "-" +
			this.state.selectedCategory.passageType;

		return this.state.passages[passageKey];
	}

	renderCategorySelector() {
		return (
			<CategoryPicker categories={ this.state.categories }
				onCategorySelect={ this.selectCategory }
				getIcon={ ClozeIcons.getIcon }
				loadingIndicator={ this.renderPlaceholder() }
				passages={ this.getCategoryPassages() } onPassageSelect={ this.selectPassage }
				selectedCategory={ this.state.selectedCategory } />
		);
	}

	renderPassage() {
		return (
			<Passage passage={ this.state.selectedPassageDetails } 
				categoryName={ this.state.selectedPassage.mainCategory }
				getIcon={ ClozeIcons.getIcon }
				subCategoryName={ this.state.selectedPassage.subCategory }
				onPassageComplete={ this.onPassageComplete } />
		);
	}

	renderPlaceholder() {
		if (this.state.finalLoading) {
			var errorMessage = "We're submitting your challenge...";
		} else {
			var errorMessage = "Hang tight, we're loading your challenge...";
		}
		return (
			<div>
				<div className="text-center lightGray">
					{ errorMessage }
				</div>
				<Spinner placeholder={ true } scale={ 1.7 } />
			</div>
		);
	}

	renderPostCompletion() {
		var status = this.state.postClozeStatus;
		var action = (status.current > status.target) ? StudentClozeStatus.DONE : StudentClozeStatus.RETAKE;
		return (
			<StudentClozeStatus status={ this.state.postClozeStatus }
				action={ action } onAction={ this.reset } />
		);
	}

	render() {
		if (this.state.finalLoading) {
			var content = this.renderPlaceholder();

		} else if (this.state.postClozeStatus) {
			var content = this.renderPostCompletion();

		} else if (this.state.selectedPassageDetails) {
			var content = this.renderPassage();	

		} else if (this.state.selectedPassage) {
			var content = this.renderPlaceholder();

		} else if (this.state.categories) {
			var content = this.renderCategorySelector();

		} else {
			var content = this.renderPlaceholder();
		}

		return (
			<div className="clozePage container" ref="wrap">
				<header className="pageHeader">
					<h1>Reading Challenge</h1>
				</header>
				{ content }
			</div>
		)
	}

	componentDidMount() {
		if ($wr.isDevelopment()) {
			this.clozeClient = new WhooosReadingClozeApi.Client("localhost:3002", "http");
		} else if ($wr.isStaging()) {
			this.clozeClient = new WhooosReadingClozeApi.Client("api.savvashortondev.com", "https");
		} else {
			this.clozeClient = new WhooosReadingClozeApi.Client("api.whooosreading.org", "https"); // Uses the default endpoint for the library
		}
		this.clozeClient.addAuth(CurrentUser.getToken());

		this.fetchCategories();
	}

	fetchCategories() {
		this.clozeClient.getCategories().then((response) => {
			if (response.diagnostic) {
				this.setState({
					selectedPassage: response.passage,
					selectedPassageDetails: response.passage_details
				});
			} else {
				this.setState({ categories: response.categories });
			}
		}).catch((error) => {
			this.showError()
		});
	}
};

ClozePage.propTypes = PageStrictPropTypes({
});

module.exports = ClozePage;


// WEBPACK FOOTER //
// ./modules/components/cloze/ClozePage.js